import * as t from "io-ts"
import { cast } from "@flockcover/flock-svc-core-types"
import { UUID } from "io-ts-types/lib/UUID"

export const FeatureFlagUnionType = t.union([
  t.literal(`flocker`),
  t.literal(`broker`),
  t.literal(`customer`),
  t.literal(`claims_admin`),
  t.literal(`carrier`),
])
export type FeatureFlagUserType = t.TypeOf<typeof FeatureFlagUnionType>

const ViewerType = t.type({
  type: FeatureFlagUnionType,
  id: UUID,
  email: t.string,
  name: t.union([t.string, t.null]),
})

export type Viewer = t.TypeOf<typeof ViewerType>
export const makeViewer = cast(ViewerType)
